/* eslint-disable react/jsx-key */
import React, { ReactElement } from 'react'

import Activity from './icons/activity'
import ActivityLog from './icons/activityLog'
import AddDocument from './icons/addDocument'
import AddUsers from './icons/addUsers'
import AlertTriangle from './icons/alertTriangle'
import Analysis from './icons/analysis'
import ApproveTick from './icons/approveTick'
import Arrow from './icons/arrow'
import ArrowRight from './icons/arrowRight'
import Assets from './icons/assets'
import AutoAwesomeCharacter from './icons/autoAwesomeCharacter'
import BarGraph from './icons/barGraph'
import BasicInfo from './icons/basicInfo'
import Benchmarking from './icons/benchmarking'
import BenchmarkManagement from './icons/benchmarkManagement'
import BlueArrow from './icons/blueArrow'
import Building from './icons/building'
import Calendar from './icons/calendar'
import Camera from './icons/camera'
import CheckWithCircle from './icons/checkWithCircle'
import CloseIntegralLogo from './icons/closeIntegralLogo'
import CognitiveBrain from './icons/cognitiveBrain'
import CollapsibleSidebar from './icons/collapsibleSidebar'
import CompetitorAnalysis from './icons/competitorAnalysis'
import Cross from './icons/cross'
import Dashboard from './icons/dashboard'
import Delete from './icons/delete'
import DocumentManagement from './icons/documentManagement'
import DollarInCircle from './icons/dollarInCircle'
import DotSearchTwo from './icons/dotSearchTwo'
import DoubleLeft from './icons/doubleLeft'
import DoubleRight from './icons/doubleRight'
import Download from './icons/download'
import EconomicAnalysis from './icons/economicAnalysis'
import Edit from './icons/edit'
import Eye from './icons/eye'
import EyeInvisible from './icons/eyeInvisible'
import EyeVisible from './icons/eyeVisible'
import FictionalLogo from './icons/fictionalLogo'
import File from './icons/file'
import Files from './icons/files'
import Filter from './icons/filter'
import Footnote from './icons/footnote'
import FunctionalAnalysis from './icons/functionalAnalysis'
import Functions from './icons/functions'
import Gear from './icons/gear'
import Graph from './icons/graph'
import GreenTick from './icons/greenTick'
import GreenTick2 from './icons/greenTick2'
import HandShake from './icons/handShake'
import HelpOutline from './icons/helpOutline'
import HelpSolid from './icons/helpSolid'
import Intangibles from './icons/intangibles'
import IntegralOpenLogo from './icons/integralOpenLogo'
import InterExchange from './icons/interExchange'
import LeftParagraph from './icons/leftParagraph'
import LegalEntityManagement from './icons/legalEntityManagement'
import LightBulb from './icons/lightBulb'
import ListBullets from './icons/listBullets'
import Loading from './icons/loading'
import LoadingThree from './icons/loadingThree'
import LocationPointer from './icons/locationPointer'
import Minus from './icons/minus'
import MoneyStack from './icons/moneyStack'
import NetworkTree from './icons/networkTree'
import OnboardingIllustration from './icons/onboardingIllustration'
import Organization from './icons/organization'
import Paragraph from './icons/paragraph'
import Percentage from './icons/percentage'
import PieChart from './icons/pieChart'
import Plus from './icons/plus'
import PrecisionManufacturing from './icons/precisionManufacturing'
import ProductCategory from './icons/productCategory'
import Reset from './icons/reset'
import Risks from './icons/risks'
import Rocket from './icons/rocket'
import Save from './icons/save'
import Search from './icons/search'
import Services from './icons/services'
import Settings from './icons/settings'
import ShoppingCart from './icons/shoppingCart'
import SideBarEclipse from './icons/sideBarEclips'
import SixDotDrag from './icons/sixDotDrag'
import Smile from './icons/smile'
import Sort from './icons/sort'
import SortDescending from './icons/sortDescending'
import SparkleStars from './icons/sparkleStars'
import StopCircle from './icons/stopCircle'
import SuccessTick from './icons/successTick'
import TemplateManagement from './icons/templateManagement'
import TemplatesSubType from './icons/templatesSubType'
import ThreeUsers from './icons/threeUsers'
import ThumbsUp from './icons/thumbsUp'
import Tick from './icons/tick'
import Transaction from './icons/transaction'
import TransactionManagement from './icons/transactionManagement'
import Upload from './icons/upload'
import UserBusinessCeo from './icons/userBusinessCeo'
import Users from './icons/users'
import Verified from './icons/verified'
import { IconsType } from './types'

const iconsMap = new Map<keyof typeof IconsType, ReactElement<IconProps>>([
  [IconsType.activity, <Activity />],
  [IconsType.activityLog, <ActivityLog />],
  [IconsType.addDocument, <AddDocument />],
  [IconsType.addUsers, <AddUsers />],
  [IconsType.alertTriangle, <AlertTriangle />],
  [IconsType.analysis, <Analysis />],
  [IconsType.approveTick, <ApproveTick />],
  [IconsType.arrow, <Arrow />],
  [IconsType.arrowRight, <ArrowRight />],
  [IconsType.assets, <Assets />],
  [IconsType.autoAwesome, <AutoAwesomeCharacter />],
  [IconsType.barGraph, <BarGraph />],
  [IconsType.basicInfo, <BasicInfo />],
  [IconsType.benchmarking, <Benchmarking />],
  [IconsType.benchmarkManagement, <BenchmarkManagement />],
  [IconsType.building, <Building />],
  [IconsType.calendar, <Calendar />],
  [IconsType.camera, <Camera />],
  [IconsType.checkWithCircle, <CheckWithCircle />],
  [IconsType.closeIntegralLogo, <CloseIntegralLogo />],
  [IconsType.cognitiveBrain, <CognitiveBrain />],
  [IconsType.collapsibleSidebar, <CollapsibleSidebar />],
  [IconsType.competitorAnalysis, <CompetitorAnalysis />],
  [IconsType.cross, <Cross />],
  [IconsType.dashboard, <Dashboard />],
  [IconsType.delete, <Delete />],
  [IconsType.documentManagement, <DocumentManagement />],
  [IconsType.dollarInCircle, <DollarInCircle />],
  [IconsType.dotSeachTwo, <DotSearchTwo />],
  [IconsType.doubleLeft, <DoubleLeft />],
  [IconsType.doubleRight, <DoubleRight />],
  [IconsType.download, <Download />],
  [IconsType.economicAnalysis, <EconomicAnalysis />],
  [IconsType.edit, <Edit />],
  [IconsType.eye, <Eye />],
  [IconsType.eyeInvisible, <EyeInvisible />],
  [IconsType.eyeVisible, <EyeVisible />],
  [IconsType.fictionalLogo, <FictionalLogo />],
  [IconsType.file, <File />],
  [IconsType.files, <Files />],
  [IconsType.filter, <Filter />],
  [IconsType.footnote, <Footnote />],
  [IconsType.functionalAnalysis, <FunctionalAnalysis />],
  [IconsType.functions, <Functions />],
  [IconsType.gear, <Gear />],
  [IconsType.graph, <Graph />],
  [IconsType.greenTick, <GreenTick />],
  [IconsType.greenTick2, <GreenTick2 />],
  [IconsType.handShake, <HandShake />],
  [IconsType.helpOutline, <HelpOutline />],
  [IconsType.helpSolid, <HelpSolid />],
  [IconsType.intangible, <Intangibles />],
  [IconsType.integralOpenLogo, <IntegralOpenLogo />],
  [IconsType.interExchange, <InterExchange />],
  [IconsType.leftParagraph, <LeftParagraph />],
  [IconsType.legalEntityManagement, <LegalEntityManagement />],
  [IconsType.lightBulb, <LightBulb />],
  [IconsType.listBullet, <ListBullets />],
  [IconsType.loading, <Loading />],
  [IconsType.loadingThree, <LoadingThree />],
  [IconsType.locationPointer, <LocationPointer />],
  [IconsType.manufacturing, <PrecisionManufacturing />],
  [IconsType.minus, <Minus />],
  [IconsType.moneyStack, <MoneyStack />],
  [IconsType.networkTree, <NetworkTree />],
  [IconsType.onboardingIllustration, <OnboardingIllustration />],
  [IconsType.organization, <Organization />],
  [IconsType.paragraph, <Paragraph />],
  [IconsType.percentage, <Percentage />],
  [IconsType.pieChart, <PieChart />],
  [IconsType.plus, <Plus />],
  [IconsType.productCategory, <ProductCategory />],
  [IconsType.reset, <Reset />],
  [IconsType.risks, <Risks />],
  [IconsType.rocket, <Rocket />],
  [IconsType.save, <Save />],
  [IconsType.search, <Search />],
  [IconsType.services, <Services />],
  [IconsType.settings, <Settings />],
  [IconsType.shoppingCart, <ShoppingCart />],
  [IconsType.sideBarEclipse, <SideBarEclipse />],
  [IconsType.sixDotDrag, <SixDotDrag />],
  [IconsType.Smile, <Smile />],
  [IconsType.sort, <Sort />],
  [IconsType.sortDescending, <SortDescending />],
  [IconsType.sparkle, <SparkleStars />],
  [IconsType.stopCircle, <StopCircle />],
  [IconsType.successTick, <SuccessTick />],
  [IconsType.templateManagement, <TemplateManagement />],
  [IconsType.templateSubType, <TemplatesSubType />],
  [IconsType.threeUsers, <ThreeUsers />],
  [IconsType.thumbsUp, <ThumbsUp />],
  [IconsType.tick, <Tick />],
  [IconsType.transaction, <Transaction />],
  [IconsType.transactionManagement, <TransactionManagement />],
  [IconsType.upload, <Upload />],
  [IconsType.userBusinessCeo, <UserBusinessCeo />],
  [IconsType.users, <Users />],
  [IconsType.verified, <Verified />],
  [IconsType.blueArrow, <BlueArrow />],
])

export const getIcons = (icons: IconsType, iconsProp?: IconProps): ReactElement<IconProps> => {
  const icon = iconsMap.get(icons)
  if (icon) {
    return React.cloneElement(icon, iconsProp)
  } else {
    return <React.Fragment />
  }
}
export interface IconProps {
  className?: string
  pathClassName?: string
}
